import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import rolService from "../services/rol.service";

const initialState = {
    roles: [],
    isLoading: false,
    isError: false,
    message: '',// Mensaje de error general
    currentPage: 1,
    totalRows: 0
};

export const getRoles = createAsyncThunk(
    "roles/getRoles",
    async (data, thunkAPI) => {
        try {
            return await rolService.getAllRoles(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createRol = createAsyncThunk(
    "rol/create",
    async (rolData, thunkAPI) => {
        try {
            return await rolService.createRol(rolData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateRol = createAsyncThunk(
    "rol/update",
    async (rolData, thunkAPI) => {
        try {
            return await rolService.updateRol(rolData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deleteRol = createAsyncThunk(
    "rol/delete",
    async (id, thunkAPI) => {
        try {
            return await rolService.deleteRol(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getSelectRols = createAsyncThunk(
    "rol/getSelectRols",
    async (_, thunkAPI) => {
        try {
            return await rolService.getSelectRols();    
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


const rolSlice = createSlice({
    name: "rol",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoles.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getRoles.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.roles = action.payload.data; // Asignar los roles obtenidos
                state.currentPage = action.payload.pagination.currentPage; // Actualizar la página actual
                state.totalRows = action.payload.pagination.totalRows; // Actualizar el total de filas
            })
            .addCase(getRoles.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createRol.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createRol.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.roles.push(action.payload); // Agregar el nuevo rol a la lista
            })
            .addCase(createRol.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateRol.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateRol.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.roles = state.roles.map((rol) => 
                rol.id === action.payload.id ? action.payload : rol);
            })
            .addCase(updateRol.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteRol.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteRol.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                const index = state.roles.findIndex(rol => rol.id === action.payload.id);
                if (index !== -1) {
                    state.roles.splice(index, 1); // Eliminar el rol de la lista
                }
            }
            )
            .addCase(deleteRol.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getSelectRols.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getSelectRols.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.roles = action.payload.data; // 👈 el payload ya es el array plano
            }
            )
            .addCase(getSelectRols.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Mensaje de error
            }
            );
    }
});
export const { reset } = rolSlice.actions;
export default rolSlice.reducer;
